import { render, staticRenderFns } from "./MoudEdit.vue?vue&type=template&id=3036bb65&scoped=true&"
import script from "./MoudEdit.vue?vue&type=script&lang=js&"
export * from "./MoudEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036bb65",
  null
  
)

export default component.exports